import { render, staticRenderFns } from "./DashIntakeReferrals.vue?vue&type=template&id=c065f55e&scoped=true&"
import script from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"
export * from "./DashIntakeReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c065f55e",
  null
  
)

export default component.exports